import type { AppLocale } from '@/utils/locale'

type TdkInfo = {
  title: string
  keywords: string
  description: string
}

const TDK_MAP: Record<AppLocale, TdkInfo> = {
  'zh-CN': {
    title: '买到手MYDOSO｜日本代购・雅虎代拍・日本转运・值得信赖的代购代拍转运平台',
    keywords:
      '日本代购,日本代拍,日本转运,日本转运公司,日本代购网站,日本雅虎代拍,日本煤炉代购,日本转运服务,日淘转运,日本海淘,日本转运公司哪家好,日本靠谱代购,日本雅虎,日本亚马逊,日本乐天,Yahoo,Mercari,Amazon,Rakuten',
    description:
      '买到手提供日本商品代购、日本 Yahoo 雅虎代拍以及日本商品转运服务。操作流程简单，价格优惠，安全高效将包裹配送至全球各地。我们提供耐心、负责的服务，人工客服长期在线协助。包裹入库前免费拍照，支持错发漏发检查与入库前检品服务，让您放心购买日本好物。',
  },
  'zh-TW': {
    title: '買到手MYDOSO｜日本代購・雅虎代拍・煤爐代買・日本集運到台灣',
    keywords:
      '日本代購,日本集運,日本煤爐代購,雅虎拍賣代拍,mercari代買,日本樂天代購,日本亞馬遜代購,日本直送,日本包稅,日本跨境代買,日本購物,日本免稅,日本海淘,日本網購,日本轉運,日本電商代購,日本超商代購,日本潮流商品代買,日本限定商品,買到手, mydoso',
    description:
      '買到手MYDOSO提供日本全方位代購與代拍服務，支援煤爐 Mercari、日本雅虎拍賣、樂天、Amazon 等上千家日本線上商城。操作簡單，代買透明免手續費，並提供日本→台灣優惠運費與包稅方案。由日本及台灣本地公司聯合營運，倉庫現場拍照、快速處理、安心可靠，是台灣用戶最方便信賴的日本購物管道。',
  },
}

const setMetaContent = (name: string, content: string, id?: string): void => {
  if (typeof document === 'undefined') return
  const byId = id ? document.getElementById(id) : null
  const el = (byId || document.querySelector(`meta[name="${name}"]`)) as HTMLMetaElement | null
  if (el) {
    el.setAttribute('content', content)
    if (id && !el.id) {
      el.id = id
    }
    return
  }
  const meta = document.createElement('meta')
  meta.setAttribute('name', name)
  meta.setAttribute('content', content)
  if (id) meta.id = id
  document.head.appendChild(meta)
}

export const applyTdk = (locale: AppLocale): void => {
  if (typeof document === 'undefined') return
  const tdk = TDK_MAP[locale] || TDK_MAP['zh-CN']
  document.title = tdk.title
  const titleEl = document.getElementById('app-title')
  if (titleEl) {
    titleEl.textContent = tdk.title
  }
  setMetaContent('keywords', tdk.keywords, 'app-keywords')
  setMetaContent('description', tdk.description, 'app-description')
}
